const DEFAULT_PARAMS = {
  order_by: "-date_created",
}

export const buildRouteQuery = (params = {}, defaults = DEFAULT_PARAMS) => {
  const searchParams = new URLSearchParams()

  Object.entries({ ...defaults, ...params }).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      searchParams.set(key, value)
    }
  })

  return searchParams.toString()
}
